import { t } from "@lingui/macro";
import { LinkSimple as LinkSimpleIcon } from "@phosphor-icons/react";
import type { URL } from "@stylingcv/schema";
import { urlSchema } from "@stylingcv/schema";
import { Button, Input, Popover, PopoverContent, PopoverTrigger, Tooltip } from "@stylingcv/ui";
import { forwardRef, useMemo } from "react";

type Props = {
  id?: string;
  value: URL;
  placeholder?: string;
  onChange: (value: URL) => void;
};

export const URLInput = forwardRef<HTMLInputElement, Props>(
  ({ id, value, placeholder, onChange }, ref) => {
    const hasError = useMemo(() => !urlSchema.safeParse(value).success, [value]);

    return (
      <>
        <div className="flex gap-x-1">
          <Input
            ref={ref}
            id={id}
            type="url"
            inputMode="url"
            autoCapitalize="none"
            autoCorrect="off"
            value={value.href}
            className="flex-1"
            hasError={hasError}
            placeholder={placeholder}
            leadingIcon={<LinkSimpleIcon size={15} />}
            onChange={(event) => {
              onChange({ ...value, href: event.target.value });
            }}
          />

          <Popover>
            <Tooltip content={t`Label`}>
              <PopoverTrigger asChild>
                <Button size="icon" variant="ghost">
                  <LinkSimpleIcon size={18} />
                </Button>
              </PopoverTrigger>
            </Tooltip>
            <PopoverContent className="p-1.5">
              <Input
                value={value.label}
                placeholder={t`Label`}
                onChange={(event) => {
                  onChange({ ...value, label: event.target.value });
                }}
              />
            </PopoverContent>
          </Popover>
        </div>

        {hasError && <small className="opacity-75">{t`URL must start with https://`}</small>}
      </>
    );
  },
);
